import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { NotificationModel } from "@boxx/messages-core/lib/models/Notification.model";

@Component({
  selector: "boxx-notifications-component",
  templateUrl: "./notifications-component.html",
  styleUrls: ["./notifications-component.scss"],
})
export class NotificationsComponent implements OnInit {
  @Input() message: NotificationModel;
  @Output() whenOpen = new EventEmitter<NotificationModel>();

  constructor() {}

  ngOnInit() {
  }

  readNotification(message){
    this.whenOpen.emit(message);
  }

}
